export enum LocationGroupType {
  HvacModeGroup = 1,
  AccessGroup = 2,
  FloorGroup = 3,
  CustomGroup = 4,
  GuestPassage = 5
}
